import type { ColorPalette, IconProps } from '@workramp/ui';
import { APP_CONSTANTS } from '~/common/explicit-exports';

/**
 * @deprecated The method should not be used, use getIconPropsSearchResult in app/javascript/src/elc/features/learner-search/utils/getIcons.ts instead
 */
export const getIconProps = (type: string, subType: string, colors: ColorPalette): IconProps => {
  switch (type) {
    case 'challenge':
      return {
        name: 'challenge:regular',
        color: colors.decorative.orange[500],
      };
    case 'guide':
      return {
        name: 'guide:regular',
        color: colors.decorative.blue[500],
      };
    case 'guide_task':
      return {
        name: 'guide:regular',
        color: colors.decorative.blue[500],
      };
    case 'guide_section':
      return {
        name: 'guide:regular',
        color: colors.decorative.blue[500],
      };
    case 'path':
      return {
        name: 'path:regular',
        color: colors.decorative.green[500],
      };
    case 'resource':
      return {
        name: 'resource:regular',
        color: colors.decorative.teal[500],
      };
    case 'library':
      return {
        name: 'library:regular',
        color: colors.decorative.purple[500],
      };
    case 'scorm':
      return {
        name: 'scorm:regular',
        color: colors.warning[500],
      };
    case 'cms_file':
      return {
        name: 'file-document:regular',
        color: colors.secondary[900],
      };
    case 'cms_link':
      return {
        name: 'link:regular',
        color: colors.secondary[900],
      };
    case 'event':
      return {
        name: 'event:regular',
        color: colors.decorative.red[500],
      };
    case APP_CONSTANTS.CONTENT_PROVIDER_TOP_LEVEL_CONTENT_TYPE:
      if (subType === APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING) {
        return {
          name: 'linkedin:brand',
          color: null,
        };
      }
      if (subType === APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY) {
        return {
          name: 'udemy:brand',
          color: null,
        };
      }
      return {
        name: null,
        color: null,
      };
    default:
      return {
        name: null,
        color: null,
      };
  }
};
